'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.imageUpload', ['angularFileUpload'])
.factory('ImageUploadField', function($log, $q, FileUploader, fileUploadFilters, showModalMessage) {
	function fileUploadFactory(name, options) {
		var imageFilter = fileUploadFilters.fileType('png', 'jpg', 'jpeg', 'gif');
		var filesizeFilter = fileUploadFilters.fileSize();

		function FileUpload(name, options) {
			this.type = 'imageUpload';

			if (!options.uploader.personalUploader) {
				this.uploader = new FileUploader(options.uploader);
				this.uploader.filters = angular.merge(this.uploader.filters, [imageFilter, filesizeFilter], options.uploader.filters || []);

				if (!options.uploader.onWhenAddingFileFailed) {
					this.uploader.onWhenAddingFileFailed = function(item, filter) {
						var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
						showModalMessage(message);
					};
				}
				if (!options.uploader.onErrorItem) {
					this.uploader.onErrorItem = function() {
						showModalMessage('Невозможно загрузить файл на сервер');
					}
				}
			} else {
				this.personalUplader = true;
				this.uploaderOptions = options.uploader;
			}

			Field.apply(this, arguments);
		}

		FileUpload.prototype = Object.create(Field.prototype);
		FileUpload.prototype.link = function(template, scope) {
			var uploader = this.uploader;

			if (this.personalUplader) {
				scope.uploader = new FileUploader(this.uploaderOptions);
				scope.uploader.filters = angular.merge(scope.uploader.filters, [imageFilter, filesizeFilter], this.uploaderOptions.filters || []);

				if (!this.uploaderOptions.onWhenAddingFileFailed) {
					scope.uploader.onWhenAddingFileFailed = function(item, filter) {
						var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
						showModalMessage(message);
					};
				}
				if (!this.uploaderOptions.onErrorItem) {
					scope.uploader.onErrorItem = function() {
						showModalMessage('Невозможно загрузить файл на сервер');
					}
				}

				uploader = scope.uploader;
			}

			var input = angular.element(template[0].getElementsByTagName('input')[0]);
			var filters = angular.isDefined(input.attr('filters')) ?
					input.attr('filters') + ',' : '';

			filters += uploader.filters.filter(function(filter) {
				return ['folder', 'queueLimit'].indexOf(filter.name) == -1;
			}).map(function(filter) {
				return filter.name;
			}).join(',');

			if (angular.isDefined(uploader.queueLimit) && uploader.queueLimit > 0) {
				filters += ',queueLimit';
			}

			input.attr('filters', filters);

			if (this.multipleUpload) {
				input.attr('multiple', true);
			}

			return $q.when(template);
		};

		return new FileUpload(name, options);
	}

	return fileUploadFactory;
});
